import { useState } from 'react';
import cx from 'classnames';
import { SlideDown } from 'react-slidedown';
import 'react-slidedown/lib/slidedown.css';

const FALLBACK_TITLE = 'We keep the spotlight on criminal justice.';
const FALLBACK_BODY =
  'Our journalism establishes facts, exposes failures and examines solutions for a criminal justice system in crisis. If you believe in what we do, become a member today.';

export default function Pitch({ copyOptions }) {
  const [collapsed, setCollapsed] = useState(true);

  const { title, body } = copyOptions;

  const renderedBody = <div dangerouslySetInnerHTML={{ __html: body }}></div>;

  const fallbackBody = <p>{FALLBACK_BODY}</p>;

  return (
    <div className="support-pitch">
      <div className="support-hed">
        <h2 className="support-subhead">{title || FALLBACK_TITLE}</h2>
        <div className="support-pitch-content">
          {body ? renderedBody : fallbackBody}
        </div>
        <div>
          <div
            className={cx('support-benefits', { collapsed })}
            onClick={() => setCollapsed(!collapsed)}
          >
            Benefits of giving to The Marshall Project
          </div>
          <SlideDown closed={collapsed}>
            {!collapsed && (
              <ul className="support-benefits-list">
                <li>
                  A tri-annual "Impact Report" on the difference our journalism
                  has made.
                </li>
                <li>
                  An annual analysis on criminal justice reform by
                  Editor-in-Chief Susan Chira.
                </li>
                <li>
                  Early access and discounted or free tickets to criminal
                  justice-related special events.
                </li>
              </ul>
            )}
          </SlideDown>
        </div>
      </div>
    </div>
  );
}
